import React from 'react'
import { View } from 'react-native'
import { twMerge } from 'tailwind-merge'

import { statusstripeContract } from './statusstripe.contract'

const STATUSES = statusstripeContract.props.status.values

export type StatusStripeStatus = (typeof STATUSES)[number]

export type StatusStripeProps = {
    status: StatusStripeStatus
    className?: string
    testID?: string
}

const variantFor = (status: StatusStripeStatus) => {
    const key = `status=${status}`
    const variant = (
        statusstripeContract.variants as Record<string, { container: string; box: string }>
    )[key]
    if (!variant) {
        throw new Error(`aos-ds StatusStripe: the Figma contract has no "${key}"`)
    }
    return variant
}

/**
 * Four pixels wide, in one of the six Figma statuses.
 *
 * The height is the one Figma draws — the stripe is a fixed 100px frame there,
 * not a filling one — so a caller that wants it to run the height of a card
 * passes `h-full` through `className` rather than the component guessing.
 */
export const StatusStripe = ({ status, className, testID }: StatusStripeProps) => (
    <View
        className={twMerge(variantFor(status).container, variantFor(status).box, className)}
        testID={testID ?? `status-stripe-${status}`}
    />
)

StatusStripe.displayName = 'StatusStripe'

export { STATUSES as STATUS_STRIPE_STATUSES }
